import CompanyVideosTab from 'src/components/pages/Company/CompanyPage/CompanyVideosTab/CompanyVideosTab';

export default CompanyVideosTab;
